import { Button, Form, Input, Cascader, Radio, Select } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import { getFolderList } from '@/api/hdd/ceiling';

import './index.scss';

export default function UploadModal() {
    const layout = {
        // labelCol: {
        //     span: 6,
        // },
        // wrapperCol: {
        //     span: 18,
        // },
        layout: 'horizontal',
    };

    const tailLayout = {
        wrapperCol: {
            offset: 9,
            span: 15,
        },
    };

    const WHOLE_HOUSE_MODEL_TYPES = ['customHome'];
    const PLACEMENT_OPTIONS = [
        { value: 2, label: '地面' },
        { value: 1, label: '墙面' },
        { value: 3, label: '顶面' },
    ];
    const DEFAULT_THUMBNAIL_OPTIONS = [
        { value: 'front', label: '正视' },
        { value: 'upward', label: '仰视' },
        { value: 'downward', label: '俯视' },
        { value: 'isometric', label: '等轴' },
    ];
    const CUSTOM_HOME_THUMBNAIL_OPTIONS = [
        { value: 'front', label: '正视' },
        { value: 'isometric', label: '左前' },
        { value: 'isometric_right', label: '右前' },
    ];

    const getThumbnailOptions = type =>
        type === 'customHome'
            ? CUSTOM_HOME_THUMBNAIL_OPTIONS
            : DEFAULT_THUMBNAIL_OPTIONS;

    const ensureThumbnailValue = (type, candidate) => {
        const options = getThumbnailOptions(type || '');
        const values = options.map(option => option.value);

        if (candidate && values.includes(candidate)) {
            return candidate;
        }

        const frontOption = options.find(option => option.value === 'front');
        if (frontOption) {
            return frontOption.value;
        }

        return values[0];
    };

    const [form] = Form.useForm();
    const [isPublish, setIsPublish] = useState(false);
    const [modelType, setModelType] = useState('');
    const [isProductLibraryRoot, setIsProductLibraryRoot] = useState(false);
    const [
        productLibraryMissingSubCategories,
        setProductLibraryMissingSubCategories,
    ] = useState(false);
    const [placementPosition, setPlacementPosition] = useState();
    const pendingPlacement = useRef({ position: undefined, height: undefined });

    const onFinish = values => {
        console.log(values);

        try {
            sessionStorage.setItem('ceilingUploadFirst', 'false');

            const params = {
                name: values.name,
                location: values.location,
                thumbnail: values.thumbnail,
            };

            if (values.placementPosition) {
                params.locationType = values.placementPosition;
            }

            if (
                values.placementHeight !== undefined &&
                values.placementHeight !== null &&
                values.placementHeight !== ''
            ) {
                params.ObjOffGround = Number(values.placementHeight);
            }

            // 如果是全屋定制，添加 categoryCode
            if (modelType === 'customHome') {
                const categoryCode = getCategoryCodeByValues(
                    options,
                    values.location
                );
                if (categoryCode) {
                    params.categoryCode = categoryCode;
                }
            }

            // 如果是点击"确定并上架"按钮，添加上架参数
            if (isPublish) {
                params.publish = true;
            }

            console.log('yt onFinish params', params);

            window.external.DispatchFun(
                'PEModelInfo',
                'PEModelInfoViewOK',
                JSON.stringify(params)
            );
        } catch (e) {
            console.log(e);
        }
    };

    const onReset = () => {
        // form.resetFields();
        onClose();
    };

    const onPublishSubmit = () => {
        setIsPublish(true);
        form.submit();
    };

    const onNormalSubmit = () => {
        setIsPublish(false);
        form.submit();
    };

    const formatTreeData = data => {
        const treeData = data.map(item => {
            return {
                label: item.name,
                value: item.id,
                pid: item.pid,
                categoryCode: item.code,
                children: item.son ? formatTreeData(item.son) : undefined,
            };
        });
        return treeData;
    };

    const applyProductLibraryDisabled = (tree, isCustomHome) => {
        const productLibraryRoot = tree[0];
        const missingSubCategories =
            isCustomHome &&
            productLibraryRoot?.label === '产品库' &&
            !(productLibraryRoot?.children?.length > 0);

        setProductLibraryMissingSubCategories(missingSubCategories);

        if (!missingSubCategories) {
            return tree;
        }

        return tree.map((node, index) =>
            index === 0 ? { ...node, disabled: true } : node
        );
    };

    const [options, setOptions] = useState([]);

    const getLabelPathByValues = (treeNodes, valuePath) => {
        const labels = [];
        let currentLevel = treeNodes;

        valuePath?.forEach(val => {
            if (!currentLevel) {
                return;
            }

            const match = currentLevel.find(option => option.value === val);

            if (match) {
                labels.push(match.label);
                currentLevel = match.children;
            } else {
                currentLevel = undefined;
            }
        });

        return labels;
    };

    const getCategoryCodeByValues = (treeNodes, valuePath) => {
        if (!valuePath?.length) {
            return undefined;
        }

        let currentLevel = treeNodes;
        let lastMatch = null;

        for (const val of valuePath) {
            if (!currentLevel) {
                break;
            }

            const match = currentLevel.find(option => option.value === val);

            if (match) {
                lastMatch = match;
                currentLevel = match.children;
            } else {
                break;
            }
        }

        return lastMatch?.categoryCode;
    };

    const updateIsProductLibraryRoot = (
        valuePath = [],
        selectedOptions,
        treeNodes
    ) => {
        if (!valuePath?.length) {
            setIsProductLibraryRoot(false);
            return;
        }

        let firstLabel;

        if (selectedOptions?.length) {
            firstLabel = selectedOptions[0]?.label;
        } else {
            const labels = getLabelPathByValues(
                treeNodes || options,
                valuePath
            );
            firstLabel = labels[0];
        }

        setIsProductLibraryRoot(firstLabel === '产品库');
    };

    useEffect(() => {
        // hdd 调用的方法
        sessionStorage.setItem('ceilingUploadFirst', 'false');

        window.GetPEModelFileInfo = info => {
            console.log('yt GetPEModelFileInfo', info);

            let fileInfo = typeof info === 'string' ? JSON.parse(info) : info;

            let isFirst = sessionStorage.getItem('ceilingUploadFirst');

            if (!isFirst || isFirst === 'false' || isFirst === 'null') {
                console.log('yt hdd 赋值了');

                const nextModelType = fileInfo?.modelType || '';
                setModelType(nextModelType);

                pendingPlacement.current = {
                    position: +fileInfo?.locationType,
                    height: fileInfo?.ObjOffGround,
                };

                form.setFieldsValue({
                    name: fileInfo?.name,
                    thumbnail: ensureThumbnailValue(
                        nextModelType,
                        fileInfo?.thumbnail
                    ),
                });

                getFolderList({
                    pid: null,
                    checkToken: true,
                    module: 'PEModelInfo',
                    type:
                        fileInfo?.modelType === 'other'
                            ? 6
                            : fileInfo?.modelType === 'customHome'
                            ? 7
                            : undefined,
                }).then(res => {
                    const tree = formatTreeData(res.data);
                    const isCustomHome = fileInfo?.modelType === 'customHome';
                    const nextTree = applyProductLibraryDisabled(
                        tree,
                        isCustomHome
                    );

                    console.log('yt getFolderLis tree', nextTree);

                    setOptions(nextTree);
                    updateIsProductLibraryRoot(
                        form.getFieldValue('location'),
                        undefined,
                        nextTree
                    );
                });

                sessionStorage.setItem('ceilingUploadFirst', 'true');
            }
        };

        document.body.classList.add('ceiling-component-upload-modal');

        document.oncontextmenu = function (event) {
            // 阻止右键菜单
            event.preventDefault();
        };

        // window.GetPEModelFileInfo({
        //     name: 'test',
        //     modelType: 'customHome',
        //     locationType: '2',
        //     ObjOffGround: 100,
        //     thumbnail: 'front',
        // });

        return () => {
            document.body.classList.remove('ceiling-component-upload-modal');
            document.oncontextmenu = null;
            sessionStorage.setItem('ceilingUploadFirst', 'false');
        };
    }, []);

    const shouldShowPlacementField =
        WHOLE_HOUSE_MODEL_TYPES.includes(modelType) && isProductLibraryRoot;

    const shouldShowPlacementHeightField =
        shouldShowPlacementField &&
        modelType === 'customHome' &&
        [2, 1].includes(placementPosition);

    useEffect(() => {
        if (!shouldShowPlacementField) {
            form.setFieldsValue({ placementPosition: undefined });
            setPlacementPosition(undefined);
        } else if (pendingPlacement.current.position !== undefined) {
            form.setFieldsValue({
                placementPosition: pendingPlacement.current.position,
            });
            setPlacementPosition(pendingPlacement.current.position);
        }
    }, [shouldShowPlacementField, form]);

    useEffect(() => {
        if (!shouldShowPlacementHeightField) {
            form.setFieldsValue({ placementHeight: undefined });
        } else if (pendingPlacement.current.height !== undefined) {
            form.setFieldsValue({
                placementHeight: pendingPlacement.current.height,
            });
        }
    }, [shouldShowPlacementHeightField, form]);

    useEffect(() => {
        const normalized = ensureThumbnailValue(
            modelType,
            form.getFieldValue('thumbnail')
        );

        form.setFieldsValue({ thumbnail: normalized });
    }, [modelType, form]);

    const handleLocationChange = (value, selectedOptions) => {
        updateIsProductLibraryRoot(value, selectedOptions);
    };

    const handleValuesChange = (_, allValues) => {
        setPlacementPosition(allValues.placementPosition);
    };

    const onClose = () => {
        console.log('yt onClose');

        try {
            sessionStorage.setItem('ceilingUploadFirst', 'false');

            window.external.DispatchFun(
                'PEModelInfo',
                'PEModelInfoViewExit',
                ''
            );
        } catch (e) {
            Promise.reject(e);
        }
    };

    return (
        <div className="upload-component-modal">
            <div className="title">
                <div className="title-word">填写模型信息</div>
                <div className="title-close" onClick={onClose}>
                    <CloseOutlined />
                </div>
            </div>
            {productLibraryMissingSubCategories && (
                <div className="product-library-tip">
                    产品库分类下没有分类，请先创建分类
                </div>
            )}
            <Form
                {...layout}
                form={form}
                onFinish={onFinish}
                onValuesChange={handleValuesChange}>
                <Form.Item
                    name="name"
                    label="模型名称"
                    rules={[
                        {
                            required: true,
                        },
                        {
                            pattern: /^[^\\/:*?"<>|；？""'']*$/,
                            message:
                                '名称不能包含 \\ / : * ? " < > | 等特殊字符',
                        },
                    ]}>
                    <Input
                        maxLength={50}
                        onPressEnter={e => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    />
                </Form.Item>
                <Form.Item
                    name="location"
                    label="所属位置"
                    className="location-cascader"
                    rules={[
                        {
                            required: true,
                        },
                    ]}>
                    <Cascader
                        options={options}
                        popupClassName="location-cascader"
                        onPressEnter={e => e.preventDefault()}
                        onChange={handleLocationChange}
                    />
                </Form.Item>
                {shouldShowPlacementField && (
                    <>
                        <Form.Item
                            name="placementPosition"
                            label="放置位置"
                            rules={[
                                {
                                    required: true,
                                    message: '请选择放置位置',
                                },
                            ]}>
                            <Select placeholder="请选择放置位置">
                                {PLACEMENT_OPTIONS.map(option => (
                                    <Select.Option
                                        key={option.value}
                                        value={option.value}>
                                        {option.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {shouldShowPlacementHeightField && (
                            <Form.Item
                                name="placementHeight"
                                label="离地高度"
                                rules={[
                                    {
                                        required: true,
                                        message: '请输入离地高度',
                                    },
                                ]}>
                                <Input
                                    type="number"
                                    min="0"
                                    placeholder="请输入离地高度"
                                />
                            </Form.Item>
                        )}
                    </>
                )}
                <Form.Item
                    name="thumbnail"
                    label="缩略图"
                    rules={[
                        {
                            required: true,
                            message: '请选择缩略图类型',
                        },
                    ]}>
                    <Radio.Group>
                        {getThumbnailOptions(modelType).map(option => (
                            <Radio key={option.value} value={option.value}>
                                {option.label}
                            </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>
                <Form.Item {...tailLayout} className="footer">
                    <Button
                        type="primary"
                        onMouseUp={onPublishSubmit}
                        disabled={productLibraryMissingSubCategories}
                        style={{ marginRight: '10px' }}>
                        确定并上架
                    </Button>
                    <Button
                        type="primary"
                        onMouseUp={onNormalSubmit}
                        disabled={productLibraryMissingSubCategories}
                        style={{ marginRight: '10px' }}>
                        确定
                    </Button>
                    <Button htmlType="button" onClick={onReset}>
                        取消
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}
